import { useEffect, useState } from 'react';

// OpponentAvatar renders an opponent club's crest and falls back to a monogram
// on load error — legacy clubs get an optimistic CDN URL that 404s when none
// was ever uploaded, and a matched Go org can drop its logo at any time. Shared
// by the match editor (MatchDetailsSection) and the calendar surfaces that
// render a fixture as a game.
export function OpponentAvatar({
  src,
  name,
  size,
  square = false,
}: {
  src: string | null;
  name: string;
  size: number;
  square?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const radius = square ? 'rounded-lg' : 'rounded-pill';
  if (!src || failed) {
    return (
      <span
        className={`flex shrink-0 items-center justify-center ${radius} bg-muted font-heading font-bold text-foreground/70`}
        style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
        aria-hidden
      >
        {name.trim().charAt(0).toUpperCase() || '?'}
      </span>
    );
  }
  return (
    <img
      src={src}
      alt=""
      onError={() => setFailed(true)}
      className={`shrink-0 ${radius} bg-background object-contain p-0.5`}
      style={{ width: size, height: size }}
      loading="lazy"
    />
  );
}
